import { render, staticRenderFns } from "./MoreCrisps.vue?vue&type=template&id=7253b4e7&scoped=true"
import script from "./MoreCrisps.vue?vue&type=script&lang=js"
export * from "./MoreCrisps.vue?vue&type=script&lang=js"
import style0 from "./MoreCrisps.vue?vue&type=style&index=0&id=7253b4e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253b4e7",
  null
  
)

export default component.exports